import { useQuery } from "@apollo/client"
import {
  // ALL_COUNTRIES,
  // ALL_REGIONS,
  ALL_LOCATIONS,
  ALL_REGIONS_LIST,
} from "../../queries/locations"
import { useEffect, useMemo, useState } from "react"

interface LocationFilter {
  regionId?: number
  countryId?: number
}
import { countries, regions } from "./data"
export const useCountries = () => {
  return {
    countries,
    countriesMap: countries.reduce((acc, country) => {
      acc.set(country.id, country)
      return acc
    }, new Map()),
    loading: false,
    error: null,
  }
}

export const useRegions = (countryId = 0) => {
  const [loading] = useState(false)
  const [error] = useState(null)

  const filteredRegions = useMemo(() => {
    if (!countryId) {
      return []
    }

    const filtered = regions.filter((region) => region.countryId === countryId)

    // Ordenar las regiones por sortOrder de forma ascendente
    filtered.sort((a, b) => a.sortOrder - b.sortOrder)

    return filtered.map((x) => {
      const name = x.name ? x.name.trim() : ""
      const alias = x.alias ? x.alias.trim() : ""
      const fullName = alias.length ? `${name} - ${alias}` : name

      return {
        ...x,
        fullName,
      }
    })
  }, [countryId])

  const regionsMap = useMemo(() => {
    return regions.reduce((acc, region) => {
      const name = region.name ? region.name.trim() : ""
      const alias = region.alias ? region.alias.trim() : ""
      const fullName = alias.length ? `${name} - ${alias}` : name

      const data = {
        ...region,
        fullName,
      }
      acc.set(region.id, data)
      return acc
    }, new Map())
  }, [])

  return {
    regions: filteredRegions,
    regionsMap,
    loading,
    error,
    // La función refetchRegions ya no es necesaria con datos locales,
    // ya que el hook se re-ejecuta al cambiar el countryId.
  }
}

/**
 *
 * @deprecated Sin uso.
 */
export const useRegionList = () => {
  const { data, loading, error, refetch } = useQuery(ALL_REGIONS_LIST, {
    errorPolicy: "all",
  })

  const [regions, setRegions] = useState<{ id: number; fullName: string }[]>([])

  useEffect(() => {
    if (data?.allRegions) {
      setRegions(data.allRegions)
    }
  }, [data])

  const refetchRegionsByCountry = async (countryId: number) => {
    const { data } = await refetch({ countryId })
    if (data?.allRegions) {
      setRegions(data.allRegions)
    }
  }

  return {
    regions,
    regionsMap: regions.reduce((acc, region) => {
      acc.set(region.id, region)
      return acc
    }, new Map()),
    loading,
    error,
    refetchRegionsByCountry,
  }
}

export const useLocations = (filter?: LocationFilter) => {
  const { data, loading, error, refetch } = useQuery(ALL_LOCATIONS, {
    variables: {
      paginate: 1000,
      filter,
      orderBy: "name_ASC",
    },
    skip: !Number(filter?.regionId),
  })

  const [locations, setLocations] = useState<{ id: number; name: string }[]>([])

  useEffect(() => {
    if (data?.allLocations) {
      setLocations(data.allLocations)
    }
  }, [data])

  const refetchLocations = async (regionId: number) => {
    if (!regionId) return
    const { data } = await refetch({
      paginate: 1000,
      filter: { regionId },
      orderBy: "name_ASC",
    })

    if (data?.allLocations) {
      setLocations(data.allLocations)
    }
  }

  return {
    locations,
    loading,
    error,
    refetchLocations,
  }
}
